import { FavoriteView } from '@iot-platform/models/common';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { FavoriteViewsActions } from '../actions';
import { AuthBusinessProfilesPageActions } from '@iot-platform/auth';

export const favoriteViewsApiFeatureKey = 'favoriteViewsApi';

export interface State extends EntityState<FavoriteView> {
  selectedFavoriteViewId: string | null;
}

export const adapter: EntityAdapter<FavoriteView> = createEntityAdapter<FavoriteView>({
  selectId: (favoriteView: FavoriteView) => favoriteView.id,
  sortComparer: false
});

export const initialState: State = adapter.getInitialState({
  selectedFavoriteViewId: null
});

export const reducer = createReducer(
  initialState,
  on(FavoriteViewsActions.loadFavoriteViewsSuccess, (state: State, { favoriteViews }): State => adapter.setAll(favoriteViews, state)),
  on(
    FavoriteViewsActions.addFavoriteViewSuccess,
    FavoriteViewsActions.addFavoriteViewFromMVSuccess,
    (state, { favoriteView }): State => adapter.addOne(favoriteView, state)
  ),
  on(
    FavoriteViewsActions.getCountForFavoriteView,
    (state, { favoriteView }): State =>
      adapter.updateOne(
        {
          id: favoriteView.id,
          changes: { loading: true }
        },
        state
      )
  ),
  on(
    FavoriteViewsActions.getCountForFavoriteViewSuccess,
    (state, { favoriteView }): State => adapter.updateOne({ id: favoriteView.id, changes: { count: favoriteView.count, loading: false } }, state)
  ),
  on(
    FavoriteViewsActions.getCountForFavoriteViewFailure,
    (state, { favoriteViewId, error }): State => adapter.updateOne({ id: favoriteViewId, changes: { count: null, loading: false } }, { ...state, error })
  ),
  on(
    FavoriteViewsActions.updateFavoriteViewSuccess,
    FavoriteViewsActions.updateFavoriteViewFromMVSuccess,
    (state, { favoriteView }): State => adapter.updateOne({ id: favoriteView.id, changes: favoriteView }, state)
  ),
  on(FavoriteViewsActions.deleteFavoriteViewSuccess, (state, { deletedFavoriteView }): State => adapter.removeOne(deletedFavoriteView.id, state)),
  on(AuthBusinessProfilesPageActions.selectBusinessProfile, (): State => initialState)
);

export const getSelectedId = (state: State) => state.selectedFavoriteViewId;
